<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('invitados')">Clientes</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Plaza Sol - Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.ci" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Cédula de Identidad o RUC" />
          <text-input v-model="form.nombres" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombres" />
          <text-input v-model="form.apellidos" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Apellidos" />
          <select-input v-model="form.contact_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Empresa">
            <option v-for="contact in contacts" :key="contact.id" :value="contact.id">{{ contact.nombres }}</option>
          </select-input>
           </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Cliente</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Crear Invitado' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    contacts: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        ci: null,
        nombres: null,
        apellidos: null,
        contacts_id: null,
         }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('invitados.store'))
    },
  },
}
</script>
